import _ from 'lodash';
import postal from 'postal';
import React from 'react';
import SignInButton from '../layout/navbar/sign-in-button';
import breakpoints from '../../shared/breakpoints';
import getScrollTop from '../../shared/get-scroll-top';
import ErrorBoundary from '../../shared/error-boundary';

export default class CampaignHeader extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.showSignUpModal = this.showSignUpModal.bind(this);
  }

  componentDidMount() {
    let onTabletOrMobile = breakpoints.upTo_medium();

    function updateOpacity() {
      const $header = $('header.campaign-header');
      const fadeTo = (() => {
        if (breakpoints.upTo_medium()) return 1;

        const scrollTop = getScrollTop();
        const headerHeight = $header.height();

        if (scrollTop > headerHeight) return 1;

        return scrollTop / headerHeight;
      })();
      const $lightLogoImg = $('#lightLogoImg');
      const $darkLogoImg = $('#darkLogoImg');

      $lightLogoImg.css('opacity', 1 - fadeTo);
      $darkLogoImg.css('opacity', fadeTo);
      $header.css({
        'background-color': `rgba(255,255,255,${fadeTo})`,
        'border-bottom': `1px solid rgba(255,255,255,${fadeTo})`,
        'box-shadow': `0 2px 5px rgba(0,0,0,${fadeTo / 2})`,
      });
    }

    $(window).on('scroll', _.throttle(() => updateOpacity(), 1000 / 60));
    $(window).on('resize', _.throttle(() => {
      updateOpacity();

      const currentlyOnTabletOrMobile = breakpoints.upTo_medium();

      if (currentlyOnTabletOrMobile !== onTabletOrMobile) {
        this.forceUpdate();
      }

      onTabletOrMobile = currentlyOnTabletOrMobile;
    }, 1000 / 60));
    updateOpacity();
  }

  // eslint-disable-next-line class-methods-use-this
  showSignUpModal(event) {
    if (event) event.preventDefault();

    postal.publish({
      channel: 'commands.campaigns',
      topic: 'present-sign-up-modal',
    });
  }

  render() {
    const onTabletOrMobile = breakpoints.upTo_medium();

    return (
      <ErrorBoundary>
        <header className="campaign-header">
          <div className="header-content">
            <a href="/">
              <img src={window.getLivewireAssetPath('livewire-logo-wht.png')} id="lightLogoImg" alt="Livewire" />
              <img src={window.getLivewireAssetPath('livewire-logo.png')} id="darkLogoImg" alt="Livewire" />
            </a>
            <div className="already-member">
              {onTabletOrMobile || <span>Already a member?</span>}
              {onTabletOrMobile && <button type="button" className="btn btn-primary" onClick={this.showSignUpModal}>Sign up</button>}
              <SignInButton />
            </div>
          </div>
        </header>
      </ErrorBoundary>
    );
  }
}
